const caretDown = "data:image/svg+xml,%3csvg%20viewBox='0%200%2010%206'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5.65062%205.7255C5.29994%206.0915%204.70006%206.0915%204.34938%205.7255L0.236866%201.43338C-0.287178%200.886447%200.115185%20-8.64158e-07%200.887484%20-7.96641e-07L9.11252%20-7.75861e-08C9.88482%20-1.00697e-08%2010.2872%200.886448%209.76313%201.43338L5.65062%205.7255Z'%20fill='%23212529'/%3e%3c/svg%3e";
export {
  caretDown as default
};
